import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { MockService } from '../../../../../types/rest/mockServiceTypes';
import Button from 'react-bootstrap/Button';
import i18n from '../../../../../i18n';
import BlazeInputDropdown, {
  BlazeDropdownItem,
} from '../../../../../components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { Col, Row } from 'react-bootstrap';
import BzmIcon from '../../../../../components/icons/BzmIcon';
import _ from 'lodash';

interface Props {
  onHide: () => void;
  mockService: MockService;
  onFinished: (flowName: string) => void;
}

const AssignMessageFlowModal = ({ onHide, mockService, onFinished }: Props) => {
  const [selectedFlow, setSelectedFlow] = useState<BlazeDropdownItem | null>(null);

  const getFlowDropdownItems = (): BlazeDropdownItem[] => {
    if (!mockService.brokerConfig?.flowConfigurations) {
      return null;
    }

    return mockService.brokerConfig.flowConfigurations.map(flow => ({
      id: flow.name,
      name: flow.name,
    }));
  };

  const getSelectedFlow = () => {
    return _.find(mockService.brokerConfig.flowConfigurations, { name: selectedFlow?.name });
  };

  const getSource = () => {
    const source = _.get(getSelectedFlow(), 'transactionMapping.sourceName', '-');
    return (
      <div>
        <h5 className={'font-weight-semi-bold'}>Inbound:</h5>
        <div className={'badge badge-primary'}>{source}</div>
      </div>
    );
  };

  const getDestinations = () => {
    const destinations = _.get(getSelectedFlow(), 'transactionMapping.destinations', []);
    const badges = _.map(destinations, dest => (
      <span className={'badge badge-primary mb-3'}>{dest.destinationName}</span>
    ));
    return (
      <div>
        <h5 className={'font-weight-semi-bold'}>Outbound:</h5>
        {_.size(badges) !== 0 ? badges : '-'}
      </div>
    );
  };

  return (
    <Modal show={true} centered={true} backdrop={true} onHide={onHide} size={'sm'}>
      <Modal.Header closeButton>
        <h5 className="modal-title">Choose Messaging Flow</h5>
      </Modal.Header>
      <Modal.Body>
        <p>Select predefined messaging flow which will be used in transactions.</p>
        <BlazeInputDropdown
          isSearchable={false}
          items={getFlowDropdownItems()}
          selected={selectedFlow}
          onClick={(item: BlazeDropdownItem) => {
            setSelectedFlow(item);
          }}
          isDefaultOptionSelectable={false}
          disabled={false}
          dropdownWidth={'100%'}
        />

        {selectedFlow && (
          <Row className={'mt-5'}>
            <Col md={5}>{getSource()}</Col>
            <Col md={2} className={'pt-6'}>
              <BzmIcon variant={'icon-bzm-arrow-right'} />
            </Col>
            <Col md={5}>{getDestinations()}</Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onHide}>
          {i18n.t('common:actions.close')}
        </Button>
        <Button
          disabled={!selectedFlow}
          variant="primary"
          onClick={() => {
            onFinished(selectedFlow.name);
          }}
        >
          Select
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignMessageFlowModal;
